module.exports = __webpack_public_path__ + "static/img/bg1920-1.22c1278.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg1920-1.jpg
// module id = A++C
// module chunks = 0